import React from "react";
import Timeline1 from "../../../assets/timeline/1.png";
import Timeline2 from "../../../assets/timeline/2.png";
import Timeline3 from "../../../assets/timeline/3.png";
import Line from "../../../assets/line.png";
import Tools from "../../../assets/icons/tools.svg";
import Lamp from "../../../assets/icons/lamp.svg";
import Console from "../../../assets/icons/console.svg";
import Camera from "../../../assets/icons/camera.svg";
import Play from "../../../assets/icons/play-warning.svg";
import Avatar1 from "../../../assets/avatar/1.png";
import Avatar2 from "../../../assets/avatar/2.png";
import Avatar3 from "../../../assets/avatar/3.png";
import Avatar4 from "../../../assets/avatar/4.png";

const Timeline = () => {

  const avatarDetails = [
    {
      name: "Naoise Holohan",
      position: "IBM Research",
      avatar: Avatar1,
    },
    {
      name: "Jack Fitzsimons",
      position: "Oblivious",
      avatar: Avatar2,
    },
    {
      name: "Michael Shoemate",
      position: "OpenDP / Harvard",
      avatar: Avatar3,
    },
    {
      name: "Joshua Allen",
      position: "Smartnoise / Microsoft",
      avatar: Avatar4,
    }
  ]

  return (
    <div className="w-full sm:mb-[150px] md:mb-[125px] mb-[100px]">
      <div className="flex items-center pb-16 relative md:flex-row flex-col justify-between md:gap-0">
        <img
          src={Line}
          className="absolute h-full top-0 left-1/2 -translate-x-1/2 md:block hidden"
          alt=":( Not Found"
        />

        <div className="md:w-full order-2 md:order-1 mx-auto mb-12 md:mb-0">
          <div className=" mx-auto sm:w-fit w-full relative">

            <img src={Timeline1} alt=":( Not Found" className="mx-auto" />

            <div className="w-[70%] max-w-[305px] absolute sm:top-0 md:-top-12 lg:scale-100 lg:top-1 sm:-right-14 -right-10 scale-[70%] sm:scale-[80%] md:scale-[65%] -top-[15%] flex flex-col gap-2">
              
              <div className="py-2 px-4 rounded-xl shadow-md bg-white">
                <div className="flex items-center w-full sm:gap-3 gap-2">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full overflow-hidden border-2 border-warning">
                    <img
                      src={avatarDetails[0].avatar}
                      className="w-full h-full"
                      alt=":( Not Found"
                    />
                  </div>
                  <div className="sm:pr-3 pr-2 flex flex-col">
                    <p className="font-semibold text-dark md:text-base text-sm ">
                      {avatarDetails[0].name}
                    </p>
                    <p className="font-semibold text-xxs text-dark opacity-40 leading-none ">
                      {avatarDetails[0].position}
                    </p>
                  </div>
                </div>
              </div>

              <div className="py-2 px-4 rounded-xl shadow-md bg-white">
                <div className="flex items-center w-full sm:gap-3 gap-2">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full overflow-hidden border-2 border-warning">
                    <img
                      src={avatarDetails[1].avatar}
                      className="w-full h-full"
                      alt=":( Not Found"
                    />
                  </div>
                  <div className="sm:pr-3 pr-2 flex flex-col">
                    <p className="font-semibold text-dark md:text-base text-sm ">
                      {avatarDetails[1].name}
                    </p>
                    <p className="font-semibold text-xxs text-dark opacity-40 leading-none ">
                      {avatarDetails[1].position}
                    </p>
                  </div>
                </div>
              </div>

              <div className="py-2 px-4 rounded-xl shadow-md bg-white">
                <div className="flex items-center w-full sm:gap-3 gap-2">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full overflow-hidden border-2 border-warning">
                    <img
                      src={avatarDetails[2].avatar}
                      className="w-full h-full"
                      alt=":( Not Found"
                    />
                  </div>
                  <div className="sm:pr-3 pr-2 flex flex-col">
                    <p className="font-semibold text-dark md:text-base text-sm ">
                      {avatarDetails[2].name}
                    </p>
                    <p className="font-semibold text-xxs text-dark opacity-40 leading-none ">
                      {avatarDetails[2].position}
                    </p>
                  </div>
                </div>
              </div>

              <div className="py-2 px-4 rounded-xl shadow-md bg-white">
                <div className="flex items-center w-full sm:gap-3 gap-2">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full overflow-hidden border-2 border-warning">
                    <img
                      src={avatarDetails[3].avatar}
                      className="w-full h-full"
                      alt=":( Not Found"
                    />
                  </div>
                  <div className="sm:pr-3 pr-2 flex flex-col">
                    <p className="font-semibold text-dark md:text-base text-sm ">
                      {avatarDetails[3].name}
                    </p>
                    <p className="font-semibold text-xxs text-dark opacity-40 leading-none ">
                      {avatarDetails[3].position}
                    </p>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>

        <div className="w-60 h-full flex-shrink-0 mb-4 md:mb-0 z-10 flex justify-center items-center order-1 md:order-2">
          <div className="md:p-4 md:bg-white mb-8 md:mb-0">
            <div className="w-[76px] h-[76px] rounded-full bg-success flex items-center justify-center font-semibold text-xl leading-normal text-dark">
              01
            </div>
          </div>
        </div>

        <div className="w-full order-3 text-center md:text-left">
          <p className="font-semibold sm:text-2xl text-xl text-dark mb-4">
            Learn about PETs
          </p>
          <p className="sm:text-xl text-base text-dark leading-normal opacity-70">
            Take part in the workshop series through October and learn about
            secure enclaves, differential privacy and synthetic data.
          </p>
        </div>

      </div>


      <div className="flex items-center pb-16 relative md:flex-row flex-col md:gap-0">
        <img
          src={Line}
          className="absolute h-full top-0 left-1/2 -translate-x-1/2 md:block hidden"
          alt=":( Not Found"
        />

        <div className="w-full order-2 md:order-3 mb-12 md:mb-0 mt-8 sm:mt-0">

          <div className="mx-auto relative w-full sm:w-fit">
            <img src={Timeline2} alt=":( Not Found" className="mx-auto"/>
            <div className="max-w-[185px] bg-dark rounded-2xl absolute sm:-top-8 -top-10 sm:-right-10 right-1 sm:p-5 p-3 text-white w-[50%] min-w-[150px] scale-[75%] md:scale-[80%] lg:scale-100">
              <div className="flex items-center sm:mb-4 mb-2">
                <div className="flex-shrink-0 sm:w-10 sm:h-10 w-8 h-8 flex items-center justify-center rounded-xl bg-[#FFFFFF10]">
                  <img src={Tools} alt=":( Not Found" />
                </div>
                <span className="pl-3 font-semibold sm:text-sm text-xs leading-5">
                  Hone your skills
                </span>
              </div>
              <div className="flex items-center">
                <div className="flex-shrink-0 sm:w-10 sm:h-10 w-8 h-8 flex items-center justify-center rounded-xl bg-[#FFFFFF10]">
                  <img src={Lamp} alt=":( Not Found" />
                </div>
                <span className="pl-3 font-semibold sm:text-sm text-xs leading-5">
                  Intuition and strategy
                </span>
              </div>
            </div>
          </div>
          

        </div>

        <div className="w-60 h-full mb-4 md:mb-0 flex-shrink-0 relative flex justify-center items-center order-1 md:order-2">
          <div className="md:p-4 md:bg-white mb-8 md:mb-0">
            <div className="w-[76px] h-[76px] rounded-full bg-success flex items-center justify-center font-semibold text-xl leading-normal text-dark">
              02
            </div>
          </div>
        </div>

        <div className="w-full order-3 md:order-1 text-center md:text-left">
          <p className="font-semibold sm:text-2xl text-xl text-dark mb-4">
            Practice in a Sandbox
          </p>
          <p className="sm:text-xl text-base text-dark leading-normal opacity-70">
            Try out each method in a sandbox so you can hone your skills, intuition and strategy.
          </p>
        </div>

      </div>


      <div className="flex items-center relative md:flex-row flex-col md:gap-0">
        <img
          src={Line}
          className="absolute h-full top-0 left-1/2 -translate-x-1/2 hidden md:block"
          alt=":( Not Found"
        />

        <div className="w-full order-2 md:order-1 mb-12 md:mb-0">
          <div className="mx-auto relative sm:w-fit w-full">
            <div className="absolute flex sm:-top-9 sm:-left-9 -top-7 left-4 scale-[85%] sm:scale-100">
              <div className="sm:w-[70px] sm:h-[70px] w-[60px] h-[60px] flex items-center justify-center bg-warning rounded-3xl shadow-icon sm:mr-6 mr-4 scale-90 lg:scale-100">
                <img src={Console} alt=":( Not Found" />
              </div>
              <div className="sm:w-[70px] sm:h-[70px] w-[60px] h-[60px] flex items-center justify-center bg-warning rounded-3xl shadow-icon scale-90 lg:scale-100">
                <img src={Camera} alt=":( Not Found" />
              </div>
            </div>
            <img src={Timeline3} alt=":( Not Found" className="mx-auto"/>
            <div className="w-full max-w-[260px] h-[72px] flex items-center shadow-md rounded-full p-4 absolute scale-[80%] sm:scale-100 -right-3 md:right-0 sm:-right-10 bottom-3 translate-y-1/2 bg-white">
              <img src={Play} className="flex-shrink-0" alt=":( Not Found" />
              <span className="pl-3 font-semibold md:text-sm text-xs text-dark leading-5">
                A 3-day live competition, join from anywhere!
              </span>
            </div>
          </div>
        </div>

        <div className="w-60 h-full mb-4 md:mb-0 flex-shrink-0 relative flex justify-center items-center order-1 md:order-2">
          <div className="md:p-4 md:bg-white mb-8 md:mb-0">
            <div className="w-[76px] h-[76px] rounded-full bg-success flex items-center justify-center font-semibold text-xl leading-normal text-dark">
              03
            </div>
          </div>
        </div>

        <div className="w-full order-3 text-center md:text-left">
          <p className="font-semibold text-xl sm:text-2xl text-dark mb-4">
            Compete Live globally on 8-11 November 2022
          </p>
          <p className="sm:text-xl text-base text-dark leading-normal opacity-70">
            Over the 3 days, compete just like any normal data science competition with the one difference: training data is only accessible via PETs.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Timeline;
